import ConditionResolver from '@/Modules/Quote/Components/QuoteForm/UiRules/Conditions/ConditionResolver.js'
import UiRule from '@/Modules/Quote/Components/QuoteForm/UiRules/UiRule.js'
import UiRuleAction from '@/Modules/Quote/Components/QuoteForm/UiRules/Actions/UiRuleAction.js'
import { IS_LOADING_GETTER } from '@/Modules/Quote/Components/QuoteForm/QuoteFormModule.js'

export default class RunUiMappings extends UiRuleAction {
    constructor(baseNode, quote, store) {
        super(baseNode, new ConditionResolver(baseNode), quote, store)
    }

    /**
     *
     * @param {object} rule
     * @returns {object} baseNode
     */
    execute(rule, node, retryCount = 0) {
        const MAX_RETRIES = 300; // 30 seconds at 100ms intervals
        let isLoading = this.store.getters[`QuoteFormModule/${IS_LOADING_GETTER}`]
        let fullNode = this.getBaseNodePropertyByJsonKey(node.nodePath)
        if (isLoading || fullNode.options.length < 1) {
            if (retryCount >= MAX_RETRIES) {
                console.warn('RunUiMappings.execute: Maximum retries reached. Unable to execute UI mapping for node:', node);
                return this.baseNode;
            }
            // can't execute before options exist since uimapping needs the value
            setTimeout(() => {
                this.execute(rule, node, retryCount + 1);
            }, 100);
        } else {
            const uiRule = new UiRule(rule)

            if (uiRule.condition && !this.resolver.evaluateCondition(uiRule)) {
                return this.baseNode
            }

            if (fullNode.uiMapping) {
                _.each(fullNode.uiMapping, (value, key) => {
                    let meta = fullNode.value.meta
                    if (!meta) {
                        meta = fullNode.options.find(option => option.value === fullNode.value)?.meta
                    }
                    const nodePath = key.replace(/\./g, '.properties.')
                    const clientValue = _.get(meta, value)
                    this.resolver.setValueToNode(nodePath, clientValue, uiRule.trigger)
                    // _.set(baseNode.properties, `${nodePath}.value`, clientValue)
                })
            }

            return this.baseNode
        }
    }

    getBaseNodePropertyByJsonKey(keyValue) {
        const value = keyValue ?? ''

        if (!value.match(/\.{\d}\./)) {
            const key = value.replace(/\./g, '.properties.')
            const property = _.get(this.baseNode.properties, key)

            return property
        }

        const multipleSectionKey = _.first(value.split(/\.{\d}\./))
        const propertyKey = _.last(value.split(/\.{\d}\./))
        const key = multipleSectionKey.replace(/\./g, '.properties.')
        const multipleSection = _.get(this.baseNode.properties, key)

        if (!_.isObject(multipleSection?.rows)) return

        return _.values(multipleSection.rows).map((row) => {
            const property = _.get(row, propertyKey.replace(/\./g, '.properties.'))

            return property
        })
    }
}
